import './single_dimension_view_base_factory.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.DefaultSingleDimensionViewFactory extends CustomerVisualMode.Charts.SingleDimensionViewBaseFactory
  canHandle: (widget) ->
    dimensions = [
      Common.WidgetDimensions.SUBTYPE,
      Common.WidgetDimensions.GROUP,
      Common.WidgetDimensions.FILTERED_GROUP,
      Common.WidgetDimensions.FILTERED_GROUP,
      Common.WidgetDimensions.TAXONOMIC_ATTRIBUTE,
      Common.WidgetDimensions.FILTERED_TAXONOMIC_ATTRIBUTE,
      Common.WidgetDimensions.TICKET_STATUS,
      Common.WidgetDimensions.ASSIGNED_OPERATOR,
      Common.WidgetDimensions.ASSIGNED_GROUP,
      Common.WidgetDimensions.CLOSED_CONVERSATIONS_PER_AGENT
    ].includes(widget.get('dimension'))

  create: (widget, data, isReadOnly, isResponsive) ->
    nameTranslator = @_nameTranslator(widget)
    valueTranslator = @_valueTranslator(widget)
    dataFormatter = new CustomerVisualMode.Charts.DataFormatter(nameTranslator, valueTranslator)
    chartView = @_chartToRender(widget, dataFormatter, data)
    new CustomerVisualMode.Charts.SingleDimensionView({
      widget: widget,
      data: data,
      session: @session,
      isReadOnly: isReadOnly,
      isResponsive: isResponsive,
      barMenu: @barMenuViewFactory.create(widget, data),
      sortDropdown: @_createSortDropdown(widget),
      nameTranslator: nameTranslator,
      valueTranslator: valueTranslator,
      dataFormatter: dataFormatter,
      chartView: chartView
    })
